import {Button, Col, Row, Spinner} from "react-bootstrap";
import {FaBoxOpen, FaQrcode, FaTruck} from "react-icons/fa";
import {
    getCommonEntityAcrossAll,
    isTransferIssuer,
    isTransferTransporter,
    to10dot1,
    transferIsPartial
} from "./constants";
import {checkPermission} from "../../../../../_helpers/commonFunctions";
import React, {useState} from "react";
import {useSelector} from "react-redux";
import RegisterTransferModal from "./RegisterTransferModal";
import DeliveryOutcomeModal from "./DeliveryOutcomeModal";
import DeliveryOutcomeReturnModal from "./DeliveryOutcomeReturnModal";
import RejectDeliveryNoteModal from "./RejectDeliveryNoteModal";
import GenerateGroupQRModal from "./GenerateGroupQRModal";

const TransfersActionButtons = ({selectedRows = [], successCallback = null, showInvalid = true}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [registerDeliveryModal, setRegisterDeliveryModal] = useState(false);
    const [deliveryOutcomeModal, setDeliveryOutcomeModal] = useState(false);
    const [deliveryOutcomeReturnModal, setDeliveryOutcomeReturnModal] = useState(false);
    const [rejectDeliveryModal, setRejectDeliveryModal] = useState(false);
    const [generateGroupModal, setGenerateGroupModal] = useState(false);
    const [loading10dot1, setLoading10dot1] = useState(false);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const renderActionButtons = () => {
        const compArr = [];
        if (selectedRows.length > 0) {
            if (selectedRows.every((el) => [0, 1].includes(el.myDataStatus))) {
                compArr.push(<Button onClick={() => setRegisterDeliveryModal(true)}><FaTruck /> Έναρξη διακίνησης</Button>)
            }
            if (selectedRows.every((el) =>
                [4, 6].includes(el.myDataStatus)
                || (transferIsPartial(el) && isTransferTransporter(el, company.vatNumber) && el.myDataStatus === 2)
            )) {
                compArr.push(<Button onClick={() => setRegisterDeliveryModal(true)}><FaTruck /> Έναρξη διακίνησης επιστροφής</Button>)
            }
            if (selectedRows.every((el) =>
                (transferIsPartial(el) && isTransferTransporter(el, company.vatNumber) && el.myDataStatus === 2)
                || (transferIsPartial(el, company.vatNumber) && isTransferIssuer(el, company.vatNumber) && el.myDataStatus === 2)
                || (isTransferIssuer(el, company.vatNumber) && [4, 6, 7].includes(el.myDataStatus))
                || ((el.invoiceType === "9.2" || el.isReverseDelivery) && isTransferIssuer(el, company.vatNumber) && el.myDataStatus === 1)
            )) {
                compArr.push(<Button onClick={() => setDeliveryOutcomeReturnModal(true)}><FaBoxOpen /> Ολοκλήρωση Διακίνησης Επιστροφής</Button>)
            }
            if (selectedRows.every((el) =>
                el.myDataStatus === 1
                || (el.myDataStatus === 2 && el.isReceiver)
            )) {
                compArr.push(<Button onClick={() => setDeliveryOutcomeModal(true)}><FaBoxOpen /> Ολοκλήρωση Διακίνησης</Button>)
            }
            if (selectedRows.every((el) => [0, 1, 2].includes(el.myDataStatus) && el.isReceiver)) {
                compArr.push(<Button variant={"outline-danger"} onClick={() => setRejectDeliveryModal(true)}>Απόρριψη διακίνησης</Button>)
            }
            if (selectedRows.length > 1 && [0, 1, 2].includes(selectedRows[0].myDataStatus) && selectedRows.every((el) => el.myDataStatus === selectedRows[0].myDataStatus)) {
                compArr.push(<Button onClick={() => setGenerateGroupModal(true)}><FaQrcode /> Δημιουργία Group QR</Button>)
            }
            if (selectedRows.length === 1 && [3].includes(selectedRows[0].myDataStatus)
                && selectedRows.every((el) =>
                    el.myDataStatus === selectedRows[0].myDataStatus
                    && company.vatNumber === el.counterpartVatNumber
                    && el.issuerVatNumber === selectedRows[0].issuerVatNumber
                )
                && checkPermission("buys-buy/new-write", permissionsData)
            ) {
                compArr.push(
                    <Button disabled={loading10dot1} onClick={() => {
                        dispatch(to10dot1(selectedRows, advancedTypesBuys, TABS_DATA, company, setLoading10dot1))
                    }}>
                        <FaTruck /> Έκδοση Ποσοτικής Παραλαβής {loading10dot1 && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size="sm" />}
                    </Button>
                )
            }
        }
        if (selectedRows.length > 0 && compArr.length === 0 && showInvalid) {
            compArr.push(<div>Οι επιλογές σας δεν δίνουν δυνατότητα επεξεργασίας Δελτίων Αποστολής. Παρακαλώ επιλέξτε Δελτία Αποστολής που βρίσκονται στην ίδια κατάσταση.</div>)
        }
        return (
            <div style={{display: "flex", gap: "15px"}}>{compArr}</div>
        )
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    {renderActionButtons()}
                </Col>
            </Row>

            <RegisterTransferModal
                show={registerDeliveryModal}
                setShow={setRegisterDeliveryModal}
                qrUrls={selectedRows.map((o) => o.qrUrl)}
                otherCorrelatedEntity={getCommonEntityAcrossAll(selectedRows)}
                defaultPD={selectedRows.length === 1 ? (selectedRows[0]?.packingsDeclarations || []) : []}
                successCallback={() => {
                    if (successCallback) successCallback();
                }}
            />

            <DeliveryOutcomeModal
                show={deliveryOutcomeModal}
                setShow={setDeliveryOutcomeModal}
                qrUrls={selectedRows.map((o) => o.qrUrl)}
                defaultPD={selectedRows.length === 1 ? (selectedRows[0]?.packingsDeclarations || []) : []}
                successCallback={() => {
                    if (successCallback) successCallback();
                }}
            />

            <DeliveryOutcomeReturnModal
                show={deliveryOutcomeReturnModal}
                setShow={setDeliveryOutcomeReturnModal}
                qrUrls={selectedRows.map((o) => o.qrUrl)}
                successCallback={() => {
                    if (successCallback) successCallback();
                }}
            />

            <RejectDeliveryNoteModal
                show={rejectDeliveryModal}
                setShow={setRejectDeliveryModal}
                qrUrls={selectedRows.map((o) => o.qrUrl)}
                successCallback={() => {
                    if (successCallback) successCallback();
                }}
            />

            <GenerateGroupQRModal
                show={generateGroupModal}
                setShow={setGenerateGroupModal}
                qrUrls={selectedRows.map((o) => o.qrUrl)}
            />
        </React.Fragment>
    )
}

export default TransfersActionButtons;
